enum StonlyGuides {
  BUSINESS_PLAN = 'QNKKoUw9Kq',
  SIMPLE = '0awu1ggUcw',
  INTEGRATION_TUTORIAL = 'D3oZJPExmV'
}

export default StonlyGuides
